<!-- 忘记密码 -->
<template>
  <div class="login-wrap">
    <div class="login">
      <!-- <img src="../../assets/img/bg.png" /> -->
      <div class="login-right">
        <img class="logo" src="../../assets/img/logo.png" />
        <div v-if="status==1">
          <h3 style="text-align: center;margin-bottom: 30px;">海量学院</h3>
          <div class="option">
            <p :class="type==1?'cur':''" @click="onCur(1,'ruleForm')">短信找回</p>
            <p :class="type==2?'cur':''" @click="onCur(2,'ruleForm')">邮箱找回</p>
          </div>
          <div class="e-form">
            <!-- 验证码登录 -->
            <el-form label-position="top" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
              <el-form-item prop="email" v-if="type==2">
                <el-input
                  placeholder="请输入邮箱"
                  v-model="ruleForm.email">
                  <i slot="prefix" class="el-input__icon el-icon-s-cooperation"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="phone" v-else>
                <el-input
                  placeholder="请输入手机号码"
                  type="number"
                  v-model="ruleForm.phone"
                  maxlength="11">
                  <i slot="prefix" class="el-input__icon el-icon-mobile-phone"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="code" class="code">
                <el-input
                  placeholder="请输入验证码"
                  v-model="ruleForm.code">
                  <i slot="prefix" class="el-input__icon el-icon-bell"></i>
                </el-input>
                <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loading" @click="submitCode" :disabled="countdown > 0"> {{ countdown > 0 ? `${countdown}秒后重新获取` : '获取验证码' }}</el-button>
              </el-form-item>

              <el-form-item prop="password">
                <el-input
                  placeholder="设置6-20位登录密码"
                  type="password"
                  v-model="ruleForm.password">
                  <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
              </el-form-item>

              <el-form-item prop="pwd">
                <el-input
                  placeholder="请再次输入登录密码"
                  type="password"
                  v-model="ruleForm.pwd">
                  <i slot="prefix" class="el-input__icon el-icon-lock"></i>
                </el-input>
              </el-form-item>
              <el-form-item class="btttom">
                <el-button style="background-color: #ff821c" size="small" type="warning" :loading="loadings" @click="submitForm('ruleForm')">{{type==1?'短信找回':'邮箱找回'}}</el-button>
              </el-form-item>
            </el-form>
          </div>
        </div>
        
        <div style="text-align: center;" v-else>
          <!-- <img class="success" src="../../assets/img/avatar.png"> -->
          <h5 class="h5">密码重置成功</h5>
          <p class="text">可通过账户密码登录，安全性高的密码可以使帐号更安全，建议您定期更换密码</p>
          <el-button style="background-color: #ff821c" class="button" size="small" type="warning"  @click="submitLogin">重新登录<span v-if="time>1" >（{{ time }}S）</span> </el-button>
        </div>
      </div>
    </div>
  </div>
    
</template>
<script type="text/ecmascript-6">
import { forgetPass,getPhoneCheckCode,getEmail} from '../../api/userMG'
import md5 from 'js-md5';
export default {
  name: 'login',
  data() {
    var password = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请输入密码'));
        } else {
          if (this.ruleForm.pwd !== '') {
            this.$refs.ruleForm.validateField('checkPass');
          }
          callback();
        }
      };
      var pwd = (rule, value, callback) => {
        if (value === '') {
          callback(new Error('请再次输入密码'));
        } else if (value !== this.ruleForm.password) {
          callback(new Error('两次输入密码不一致!'));
        } else {
          callback();
        }
      };
    return {
      status:1,
      type:2,
      ruleForm:{
        email:'',
        phone:'',
        code:'',
        password:'',
        pwd:''
      },
      rules: {
        name: [
          { required: true, message: '请输入用户名', trigger: 'blur' }
        ],
        email: [
          { required: true, message: '请输入邮箱', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入手机号', trigger: 'blur' }
        ],
        code: [
          { required: true, message: '请输入验证码', trigger: 'blur' }
        ],
        password: [
          { validator: password, trigger: 'blur' },
          { min: 6, max: 20, message: '长度在 6 到 20 个字符', trigger: 'blur' }
        ],
        pwd: [
          { validator: pwd, trigger: 'blur' },
        ],
      },
      checked:false,
      countdown: 0, // 倒计时秒数
      intervalId: null, // 存储interval的id
      time:5,
      loading:false,
      loadings:false
    }
  },
  comments(){
    if(this.time<1){
      this.$router.push({path:'/login/login'})
    }
  },
  // 创建完毕状态(里面是操作)
  created() {
    
  },
  // 里面的函数只有调用才会执行
  methods: {
    onCur(e,formName){
      this.type = e;
      this.$refs[formName].resetFields();
    },
    submitCode(){
      let params;
      let sign = md5(this.ruleForm.phone+'ZHE_GE_JIE_KOU_YI_JIN_JIA_MI_LE')
      if(this.type == 1){
        let reg = 11 && /^((13|14|15|17|18)[0-9]{1}\d{8})$/;
        if(!this.ruleForm.phone){
          this.$message({
            message: '请输入手机号',
            type: 'warning'
          });
          return
        }
        if(!reg.test(this.ruleForm.phone)){
          this.$message({
            message: '手机号格式不正确',
            type: 'warning'
          });
          return
        }
        this.loading = true;
        params = {
          phoneNum:this.ruleForm.phone,
          sign:sign
        }
        getPhoneCheckCode(params).then(res => {
          if(res){
            this.loading = false;
            this.startCountdown(60);
            console.log('验证码',res);
          }
        })
        .catch(err => {
          this.loading = false;
          this.$message.error('验证码获取失败，请稍后再试！')
        })
        
      }else{
        let regEmail = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
        if(!this.ruleForm.email){
          this.$message({
            message: '请输入邮箱',
            type: 'warning'
          });
          return
        }
        if(!regEmail.test(this.ruleForm.email)){
          this.$message({
            message: '邮箱格式不正确',
            type: 'warning'
          });
          return
        }
        this.loading = true;
        params = {
          email:this.ruleForm.email
        }          
        getEmail(params).then(res => {
          if(res){
            this.loading = false;
            this.startCountdown(60);
            console.log('验证码',res);
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('验证码获取失败，请稍后再试！')
        })
      }
    },
    startCountdown(seconds) {
      this.countdown = seconds;
      this.intervalId = setInterval(() => {
        if (this.countdown > 0) {
          this.countdown -= 1;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loadings = true;
          this.ruleForm.account = this.type==1?this.ruleForm.phone:this.ruleForm.email;
          console.log(this.ruleForm)
          console.log(this.ruleForm.account)
          forgetPass(this.ruleForm).then(res => {
            console.log('重置',res);
            this.loadings = false
            if(res){
              this.status = 2
            }
          })
          .catch(err => {
            this.loading = false
            console.log(err)
            this.$message.error('重置密码失败，请稍后再试！')
          })
        } else {
          console.log('error submit!!');
          return false;
        }
      });

      this.time = 5;
      this.intervalId = setInterval(() => {
        if (this.time > 0) {
          this.time -= 1;
        } else {
          clearInterval(this.intervalId);
        }
      }, 1000);
    },
    submitLogin(){
      this.$router.push({path:'/login/login'})
    }
  }
}
</script>

<style scoped>
  @media (min-width: 1366px) {
    .login { 
        width: 1000px;
      }
    }
  @media (min-width: 1600px) {
    .login {
      width: 1300px;
    }
  }
  .login-wrap{
  width: 100%;
  background-image: url('../../assets/img/back2.png');
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%;
}
.login{
  display: flex;
  align-items: center;
  justify-content: center;
  /* background-image: url('../../assets/img/bg.png');
  background-repeat: no-repeat;
  background-position: center right;
  background-size: 100%; */
  height: 400px;
}
.login img{
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.login-right{
  width: 400px;
  padding: 40px 100px;
  background-image: linear-gradient(bottom,#fff,#fff8f2);
  box-shadow: 0 0 20px rgba(222, 207, 207, 0.8);
  border-radius: 10px;
}
.login-right .logo{
  width: 140px;
  margin: 0 auto 20px;
}
.option{
  display: flex;
  align-items: center;
  justify-content: center;
}
.option {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 20px;
}
.option p{
  width: 50%;
  text-align: center;
  font-size: 13px;
  border-bottom: 3px solid #efefef;
  padding-bottom: 12px;
  cursor: pointer;
}
.option .cur{
  border-bottom: 3px solid #ff821c;
}
.e-form .key{
  font-size: 13px;
  color: #666;
  margin-bottom: 6px;
}
.e-form .prop{
  color: #ff821c;
  margin-right: 2px;
}
.e-form /deep/ .el-form--label-top .el-form-item__label{
  padding: 0 !important;
} 
.e-form /deep/ .el-button--small{
  width: 100%;
  padding: 12px 0;
}
.code /deep/ .el-button--small{
  width: auto;
  padding: 12px 20px;
}
.tip{
  display: flex;
  align-items: center;
  justify-content: center;
}
.tip p{
  font-size: 11px;
  color: #999999;
}
.tip p span{
  font-size: 11px;
  color: #ff821c;
  cursor: pointer;
}
.code /deep/ .el-form-item__content{
  display: flex;
}
.btttom{
  margin-top: 20px;
}
.el-checkbox__label{
  font-size: 10px;
}
.checked span{
  font-size: 10px;
}
.checked .checkbox-span{
  color: #ff821c;
  cursor: pointer;
}
.checked /deep/ .el-checkbox__label{
  color: #999 !important;
  font-size: 10px;
  padding-left: 6px;
}
.checked /deep/ .is-checked .el-checkbox__inner{
  background-color: #ff821c;
}
.checked /deep/ .el-checkbox__inner{
  width: 12px;
  height: 12px;
  border: 1px solid #ff821c;
  margin-top: 2px;
}
.success{
  width: 60px !important;
  height: 60px;
  margin: 30px auto;
}
.h5{
  text-align: center;
}
.text{
  text-align: center;
  font-size: 10px;
  color: #999;
}
.button{
  width: 300px;
  margin-top: 50px;
  height: 40px;
}
</style>


// WEBPACK FOOTER //
// src/views/login/forget.vue